import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id,
    parentId = '',
    title,
    icon,
    ctype,
    srcId,
    url,
    target,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.menu.save, {
        id,
        parentId,
        title,
        icon,
        ctype,
        srcId,
        url,
        target,
    }, options);
    if (error) return { error, status };
    return content || {};
};

